module.exports = __webpack_public_path__ + "media/images/logo_novum_social_media-8b11d520814ff3ddd858de5b35383918.jpg";